/*
 * @FileName       : main.tsx
 * @Version        : 1.0
 * @DateOfCreation : 04/17/2020
 * @Author         : $u^^!t@FFFEnterprises
 * @Dependencies   : N/A
 * @Description    : Main Entry file for application.
 *
 * Copyright (c) 2020, FFFEnterprises. All rights reserved.
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore, { history } from './redux/store/store';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './assets/css/app.scss';
import Routes from './routes/routes';

// Check if Hotjar has been initialized before calling its methods
// if (hotjar.initialized()) {
//   console.log('HOTJAR IS INITIALIZED')
// }

//if user previously selected dark theme, we save it in the DB and also localStorage
//this way, we avoid a "flash" by pre-setting Body dark-mode css before the user service has returned
const preloadDarkTheme = localStorage.getItem('fdiPortal_themePreference') === 'dark';
const bgColor = preloadDarkTheme ? '#303030' : '#fff';
const textColor = preloadDarkTheme ? '#fff' : '#000';

const css = `
    body {
      background-color: ${bgColor};
      color: ${textColor};
      height: 100%
    },
    html {
      height: 100%
    }
`;

ReactDOM.render(
	<>
		<style>{css}</style>
		<DndProvider backend={HTML5Backend} />
		<Provider store={configureStore({})}>
			<ConnectedRouter history={history} />
			<Routes />
		</Provider>
	</>,
	document.getElementById('root'),
);
